import PubSub from 'pubsub-js';

export const RO_LOCK_DEACTIVATION_EVENT_ID = Symbol('7T:RoLock.Deactivation');

export const roLockDeactivationPubSub:
PubSubJS.Base<undefined, typeof RO_LOCK_DEACTIVATION_EVENT_ID> = PubSub;
